import { Rule } from '../../Rules'

const changesRules: Array<Rule> = [
  {
    details: 'Yes.  We added a minting reward.',
    reason: 'The price of gas on the Ethereum network has become a systemic problem, and to address this we added a minting reward.',
    summary: 'Are there any rule changes in XYO World 2.0?',
  },
  {
    details:
      "When a new geotoken is minted, there is a 10% minting reward that is taken directly from the final amount of XYO Tokens in the geotoken. For example, if someone completed the auction at 1M XYO tokens, the minting reward would be 100,000 of those XYO tokens. During the first 24 hours after the end of the auction, the highest bidder (winner) of the auction has exclusive minting reward rights; regardless of who mints the token, the minting reward will be sent to the bidder's wallet. After 24 hours, anyone can mint the token, and the 10% reward will be sent to the wallet used to mint the geotoken.",
    reason:
      'With high ETH gas prices, we want to give the winner of the geotoken 24 hours to optimize when to mint their new geotoken while still preventing geotokens from going unminted.',
    summary: 'How does this new minting fee work?',
  },
  {
    details:
      'This depends on whether or not the winner mints the geotoken in the first 24 hours following the end of the auction.  If they do, they actually receive more tokens than they would have in the 1.0 rules, and slightly less tokens flow to the parent geotokens.  If someone else mints the geotoken after the first 24 hours, then the winner retains less of the minting deposit.',
    reason:
      'With high ETH gas prices, we want to give the winner of the geotoken 24 hours to optimize when to mint their new geotoken while still preventing geotokens from going unminted.',
    summary: 'Is the minting reward better or worse for the winner?',
  },
]

export default changesRules
